class LoansDetailMinimumFeeController {
  constructor() {
  }
}

export default LoansDetailMinimumFeeController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailMinimumFee/loansDetailMinimumFee.controller.js